const features = [
  {
    icon: 'ri-calendar-check-line',
    title: 'SMART BOOKING, LESS WAITING',
    description: 'Secure your spot ahead of time, walk in still welcome.',
  },
  {
    icon: 'ri-time-line',
    title: 'OPEN DAILY, FLEXIBLE HOURS',
    description: "We're open every day to fit your routine.",
  },
  {
    icon: 'ri-medal-line',
    title: 'RELIABLE RESULTS EVERY TIME',
    description: 'No guesswork, just clean, sharp, consistent cuts.',
  },
  {
    icon: 'ri-focus-2-line',
    title: 'TAKE YOUR TIME, NO RUSH',
    description: "We focus on getting it right, not just getting it done.",
  },
  {
    icon: 'ri-star-line',
    title: 'DETAILS THAT MAKE THE DIFFERENCE',
    description: 'From fades to finished, every part of your cut matters.',
  },
  {
    icon: 'ri-heart-line',
    title: "A PLACE YOU'LL WANT TO COME BACK TO",
    description: 'A relaxed atmosphere, great energy, and consistent service every time.',
  },
  {
    icon: 'ri-store-3-line',
    title: 'BUILT FOR COMFORT',
    description: 'A modern space designed for a clean, comfortable experience.',
  },
];

export default function WhyChoose() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="text-red-600 text-xs tracking-widest font-semibold mb-4 whitespace-nowrap">WHY REBORN</div>
          <h2 className="text-6xl md:text-7xl font-bold text-black leading-tight mb-6">
            More Than a Haircut.<br />
            A Better Experience.
          </h2>
        </div>

        {/* Features Grid — 4 on top, 3 centered below */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
          {features.slice(0, 4).map((feature, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-2xl p-8 hover:border-red-200 hover:bg-red-50/30 transition-all group"
            >
              <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-base font-bold text-black mb-3 leading-tight tracking-wide">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed text-sm">{feature.description}</p>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:w-3/4 mx-auto">
          {features.slice(4).map((feature, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-2xl p-8 hover:border-red-200 hover:bg-red-50/30 transition-all group"
            >
              <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-base font-bold text-black mb-3 leading-tight tracking-wide">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed text-sm">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
